import {AsyncPipe, DatePipe} from "@angular/common";
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MatIconButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {Asset, AssetService} from "@app/asset";
import {TagInspectorComponent} from "@app/inspector/tag-inspector/tag-inspector.component";
import {MarkdownTextareaComponent} from "@app/shared/markdown-textarea/markdown-textarea.component";
import {User} from "@app/shared/user.service";
import {MarkedPipe} from "@shared/marked.pipe";
import {Observable} from 'rxjs';
import {debounceTime, filter, map} from 'rxjs/operators';

@Component({
  selector: 'frog-review-asset-info',
    imports: [
        AsyncPipe,
        DatePipe,
        MarkedPipe,
        MatIcon,
        MatIconButton,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MarkdownTextareaComponent,
        TagInspectorComponent,
    ],
  templateUrl: './review-asset-info.component.html',
  styleUrl: './review-asset-info.component.scss'
})
export class ReviewAssetInfoComponent implements OnInit, OnChanges {
    @Input() asset!: Asset;
    @Input() user!: User;
    @Output() infoLock: EventEmitter<boolean>;

    public form: UntypedFormGroup;
    public dirty$: Observable<any>;

    private initialValue: { name: string; description: string };

    constructor(
        private assetService: AssetService,
        private formBuilder: UntypedFormBuilder,
    ) {
        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            description: '',
        });
        this.infoLock = new EventEmitter<boolean>()
    }

    ngOnInit(): void {
        this.updateFormForAsset();
        this.dirty$ = this.form.valueChanges.pipe(
            filter((formValue: { name: string; description: string }) => {
                return (
                    formValue.name !== this.initialValue.name ||
                    formValue.description !== this.initialValue.description
                );
            }),
            debounceTime(1000),
            map(() => this.save()),
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['asset'] && !changes['asset'].firstChange) {
            this.updateFormForAsset();
        }
    }

    private updateFormForAsset(): void {
        if (this.asset === undefined || this.asset === null) {
            return;
        }

        this.initialValue = {
            name: this.asset.name,
            description: this.asset.description,
        };
        this.form.setValue(this.initialValue);
    }

    close(): void {
        this.infoLock.emit(false);
    }

    save() {
        this.assetService.updateAsset(this.asset.id, this.form.value);
    }
}
